<button class="btn btn-outline-primary" (click)="addInfoRectif()">{{ step9.ajouterInfoRectif  | translate }}</button>
<div *ngFor="let obj of rectificatif?.infosRectif; let i = index">
<div *ngIf="i!==0">   
<button class="btn btn-outline-primary" (click)="removeInfo(i)">{{ step9.supprimer | translate }}</button>
</div> 
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="obj"
    [label]="step9.infosRectif" [type]="'text'" [rule]="'required'"
    [name]="getUid() +'_index_'+(i+1)+'_SepAtt_infosRectif'">
</app-form-input>
<span>{{ step9.getinfoRectificative | translate }}</span>
</div>
